import React from 'react';
import classNames from 'classnames';

import FileTransferToast from '../../../../attachments/FileTransferToast';
import { useImageModalV2SurfaceLifecycle } from './useImageModalV2SurfaceLifecycle';

import './ImageModalV2FileTransferToast.scss';

const EXIT_FALLBACK_MS = 150;

/**
 * Modal-owned wrapper that lets the shared file-transfer (upload/download) toast participate in the
 * bottom-surface handoff, so it slides down toward the toolbar band on exit like the operation and
 * error toasts rather than being unmounted mid-frame.
 */
const ImageModalV2FileTransferToast: React.FC<{
    elementId: string;
    uploadLoadingLabel: string;
    isOpen: boolean;
    onExitComplete: () => void;
}> = ({ elementId, uploadLoadingLabel, isOpen, onExitComplete }) => {
    const { isShown, hasEntered, handleTransitionEnd } = useImageModalV2SurfaceLifecycle({
        isOpen,
        fallbackMs: EXIT_FALLBACK_MS,
        onExitComplete,
    });

    return (
        <FileTransferToast
            elementId={elementId}
            groupId="ImageModalV2"
            uploadLoadingLabel={uploadLoadingLabel}
            motion={{
                className: classNames({
                    'is-shown': isShown,
                    'has-entered': hasEntered,
                }),
                onTransitionEnd: handleTransitionEnd,
            }}
        />
    );
};

export default ImageModalV2FileTransferToast;
